module.exports = __webpack_public_path__ + "Tamilnadu-Assembly-NEW-7544ecae3f8f78b90de1.svg";